var _path, _path2, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3554_531)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3554_531",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0026 25.6667C15.535 25.6687 17.0527 25.3678 18.4684 24.7814C19.8841 24.195 21.17 23.3345 22.2521 22.2495C23.3371 21.1674 24.1975 19.8815 24.784 18.4658C25.3704 17.0501 25.6713 15.5324 25.6693 14.0001C25.6712 12.4677 25.3703 10.95 24.7839 9.5343C24.1975 8.11858 23.3371 6.8327 22.2521 5.75055C21.17 4.66557 19.8841 3.80513 18.4684 3.2187C17.0527 2.63227 15.535 2.3314 14.0026 2.33338C12.4702 2.33143 10.9526 2.63231 9.53686 3.21874C8.12114 3.80518 6.83526 4.66559 5.75311 5.75055C4.66816 6.8327 3.80774 8.11858 3.22131 9.5343C2.63488 10.95 2.33399 12.4677 2.33595 14.0001C2.33396 15.5324 2.63483 17.0501 3.22126 18.4658C3.8077 19.8815 4.66813 21.1674 5.75311 22.2495C6.83526 23.3345 8.12114 24.1949 9.53686 24.7814C10.9526 25.3678 12.4702 25.6687 14.0026 25.6667Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 14L12.8359 17.5L19.8359 10.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3554_531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "#3FB36D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3554_531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.fd1534ee.svg";
export { ForwardRef as ReactComponent };